<app-spinner *ngIf="odmLoading && bslLoading" [sizeClass]="'large'"><span class="waiting-message" translate>T_OFFER_DATA_MANAGEMENT_LOADING_TIME</span></app-spinner>
<div *ngIf="!odmLoading || !bslLoading">
    <h1 class="offer-selection-title" translate>T_CHOOSE_AN_OFFER_TO_MODIFY_OR_TO_ADD</h1>
    <div>
        <se-tabbar option="content">
            <nav>
                <span *ngFor="let tab of getTabs()" [ngClass]="{'active':tab.active}" (click)="selectTab(tab)" translate>{{tab.title}}</span>
            </nav>
        </se-tabbar>
        <div class="offer-selection-container" *ngIf="isTabActive(1)">
            <app-odm-list-offers
                    [titleHeader]="'T_MY_CURRENT_RANGES'"
                    [rangesObservable]="getStandardRanges()"
                    [orderList]="true"
                    [showImportExportButtons]="false"
                    [loading]="odmLoading"
                    (onClickOnComponentManagement)="goToComponentManagement($event)"
                    (onClickOnAccessoriesManagement)="goToAccessoriesManagement($event)"
                    (onClickOnOptionsManagement)="goToOptionsManagement($event)"
                    (onChangeRangeOrder)="updateRangeOrder($event, 'STANDARD')"
                    (onDecommissionRange)="decommissionRange($event)"
                    (saveRangeInfo)="onSaveRangeInfo($event)"
                    (transformRangeInfo)="onTransformRangeSelector($event)"
                    (onTransformImportedRange)="transformImportedRange($event)"
                    (onPublishRange)="publishRange($event)">
            </app-odm-list-offers>
        </div>

      <div class="offer-selection-container" *ngIf="isTabActive(2)">
        <app-odm-list-offers
          [titleHeader]="'T_MY_IMPORTED_RANGES'"
          [rangesObservable]="getImportedRanges()"
          [orderList]="true"
          [loadingImportExport]="loadingImportExport"
          [showImportExportButtons]="true"
          [loading]="odmLoading"
          (onClickOnComponentManagement)="goToComponentManagement($event)"
          (onClickOnAccessoriesManagement)="goToAccessoriesManagement($event)"
          (onClickOnOptionsManagement)="goToOptionsManagement($event)"
          (onChangeRangeOrder)="updateRangeOrder($event, 'IMPORTED')"
          (onDecommissionRange)="decommissionRange($event)"
          (onClickRangeImport)="rangeImport($event,'IMPORTED')"
          (onClickRangeExport)="rangeExport($event)"
          (saveRangeInfo)="onSaveRangeInfo($event)"
          (transformRangeInfo)="onTransformRangeSelector($event)">
        </app-odm-list-offers>
      </div>
      <div class="offer-selection-container" *ngIf="isTabActive(3)">
        <app-odm-list-offers
          [titleHeader]="'T_RANGES_AVAILABLE_FOR_MY_COUNTRY'"
          [rangesObservable]="availableRanges"
          [orderList]="false"
          [showImportExportButtons]="false"
          [loading]="bslLoading"
          (onClickOnRangeAddition)="goToRangeAddition($event)">
        </app-odm-list-offers>
      </div>
      <div class="offer-selection-container" *ngIf="isTabActive(4)">
        <app-odm-list-offers
          [titleHeader]="'T_MY_BUDGETARY_QUOTE_RANGES'"
          [rangesObservable]="getBudgetaryQuoteImportedRanges()"
          [orderList]="true"
          [loadingImportExport]="loadingImportExport"
          [isBudetaryQuote]="true"
          [showImportExportButtons]="true"
          [loading]="odmLoading"
          (onClickOnComponentManagement)="goToComponentManagement($event)"
          (onClickOnAccessoriesManagement)="goToAccessoriesManagement($event)"
          (onClickOnOptionsManagement)="goToOptionsManagement($event)"
          (onChangeRangeOrder)="updateRangeOrder($event, 'BUDJETARY_QUOTE')"
          (onDecommissionRange)="decommissionRange($event)"
          (onClickRangeImport)="rangeImport($event, 'BUDJETARY_QUOTE')"
          (onClickRangeExport)="rangeExport($event)"
          (onClickOnRangeAddition)="goToRangeAddition($event)"
          (saveRangeInfo)="onSaveRangeInfo($event)">
        </app-odm-list-offers>
      </div>
    </div>
</div>
